// src/config.js

// export const API_BASE_URL = 'http://localhost:5000/api';
export const API_BASE_URL = '/api';


